import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { useSettings } from "@/lib/settings";

export default function About() {
  const { settings } = useSettings();
  const name = settings.site_name || "MOBIKAR";
  return (
    <div className="min-h-screen bg-[#f8f9fa]">
      <SiteHeader />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="text-xs uppercase tracking-[0.2em] text-[#0e7a3f] font-bold">À propos</div>
        <h1 className="font-display text-4xl md:text-5xl font-black text-[#0a1e3f] mt-2">{settings.tagline}</h1>
        <div className="mt-8 bg-white rounded-3xl p-8 border border-gray-100 mbk-card-shadow space-y-4 text-gray-600 leading-relaxed">
          <p><b className="text-[#0a1e3f]">{name}</b> est la plateforme premium de réservation de véhicules en Afrique. Nous connectons les voyageurs aux meilleures agences locales pour une expérience simple, fiable et sécurisée.</p>
          <p>De Pointe-Noire à Abidjan, en passant par Dakar et Brazzaville, {name} vous accompagne partout où vous allez, avec ou sans chauffeur.</p>
          <p>Notre engagement : des agences vérifiées, des véhicules récents, un service 7j/7 et une réservation 100% sécurisée.</p>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
